import type { AppointmentStatus } from '@bb/domain/dist/types';
import type { AppointmentsMyBusinessDTOV2 } from '@bb/domain/dist/types/dto/AppointmentController/appointmentsMyBusiness';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import moment from 'moment';

export type AppointmentsMyBusinessOptions = {
  searchType?: 'user' | 'team';
  dateFrom?: Date | moment.Moment;
  dateTo?: Date | moment.Moment;
  sort_field?: string;
  sort_asc?: boolean;
  pageNumber: number;
  preferences?: AppointmentStatus[] | AppointmentStatus;
  docType?: 'appointment' | 'virtualTour';
  address?: string;
  withPermissions?: true;
  withRepData?: boolean;
  includeConfirmedPendingAppointment?: boolean;
  excludeConfirmedPendingAppointment?: boolean;
  includeSignatures?: boolean;
  includeActionCount?: boolean;
  useV2Logic: true;
  targetTeamId?: string;
};

const appointmentsMyBusiness = async ({
  searchType,
  dateFrom,
  dateTo,
  sort_field,
  sort_asc,
  pageNumber,
  preferences,
  docType,
  address,
  withPermissions,
  withRepData,
  includeConfirmedPendingAppointment,
  excludeConfirmedPendingAppointment,
  includeSignatures,
  includeActionCount,
  useV2Logic,
  targetTeamId,
}: AppointmentsMyBusinessOptions) => {
  const config: AxiosRequestConfig = {
    url: '/appointment/my_business/page',
    method: 'get',
    params: {
      searchType,
      dateFrom: dateFrom
        ? moment(dateFrom).startOf('day').toISOString()
        : undefined,
      dateTo: dateTo ? moment(dateTo).endOf('day').toISOString() : undefined,
      sort_field,
      sort_asc,
      pageNumber,
      preferences,
      docType,
      address,
      withPermissions,
      withRepData,
      includeConfirmedPendingAppointment,
      excludeConfirmedPendingAppointment,
      includeSignatures,
      includeActionCount,
      useV2Logic,
      targetTeamId,
    },
  };

  const { data } = await axios.request<AppointmentsMyBusinessDTOV2>(config);

  return data;
};

export default appointmentsMyBusiness;
